import React from 'react'

/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {http} from '@helpers/common'
import Editor from '@components/editor'
import {DefaultComponentProps} from '@interface/common'

/**
 * Components
 */
import Button from '@components/button'

/**
 * Template Settings Screen
 */
export default pure(({store}: DefaultComponentProps) => {
  const state = store.useLocalState({
    error: false,
    download: {
      ios: '',
      title: '',
      content: '',
      android: '',
      redirect: '',
    },
    inviteOrganizations: {
      title: '',
      content: '',
    },
    inviteParents: {
      title: '',
      content: '',
    },
  })

  React.useEffect(() => {
    http.get('/settings', {
      query: {
        fields: [
          'download',
          'inviteParents',
          'inviteOrganizations',
        ]
      }
    })
    .then(({status, result}:any) => {
      if(status === 200 && result) {
        state.set(result)
      }
    })
    .catch(console.log)
  }, [])

  
  /**
   * Save settings
   */
  function save() {
    state.set({
      saving: true
    })
    
    http.put('/settings', {
      data: {
        download: state.download,
        inviteParents: state.inviteParents,
        inviteOrganizations: state.inviteOrganizations,
      }
    })
    .then(({status, result}:any) => {
      if(status === 200) {
        if(result) {
          state.set({saving: false, ...result})
        }
      }
    })
    .catch(console.log)
  }


  /**
   * Handle change
   */
  function change(name: string, data: object) {
    state.set((state: any) => {
      return {
        [name]: {...state[name], ...data}
      }
    })
  }


  return (
    <div className="box">
      <header className="line">
        <h3>General Settings</h3>
      </header>
      
      <div
        style={{
          width: '50%'
        }}>
        <fieldset className="fields">
          <div style={{marginBottom: 40}}>
            <h4 style={{marginBottom: 5}}>Download</h4>
            <p>The information below will be use for sharing the app to the other platform to invite someone to download the app.</p>
          </div>
          <div className="field">
            <label>Title</label>
            <input
              type="text"
              value={state.download.title}
              onChange={(e) => {
                change('download', {title: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>Message</label>
            <textarea
              value={state.download.content}
              onChange={(e) => {
                change('download', {content: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>App Store</label>
            <input
              type="text"
              value={state.download.ios}
              onChange={(e) => {
                change('download', {ios: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>Google Play</label>
            <input
              type="text"
              value={state.download.android}
              onChange={(e) => {
                change('download', {android: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>Redirect URL</label>
            <input
              type="text"
              value={state.download.redirect}
              onChange={(e) => {
                change('download', {redirect: e.target.value})
              }}
            />
          </div>
        </fieldset>
        <fieldset className="fields">
          <h4>Invite Organizations</h4>
          <p>An email invitation template to send to organization.</p>
          
          <div className="field">
            <label>Title</label>
            <input
              type="text"
              value={state.inviteOrganizations.title}
              onChange={(e) => {
                change('inviteOrganizations', {title: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>Content</label>
            <div className="editor">
              {state.inviteOrganizations.content && (
                <Editor
                  content={state.inviteOrganizations.content}
                  onChange={({content}: {content: string}) => {
                    change('inviteOrganizations', {content})
                  }}
                />
              )}
            </div>
          </div>
        </fieldset>

        <fieldset className="fields">
          <h4>Invite Parents</h4>
          <p>An email invitation template to send to parents.</p>
          <div className="field">
            <label>Title</label>
            <input
              type="text"
              value={state.inviteParents.title}
              onChange={(e) => {
                change('inviteParents', {title: e.target.value})
              }}
            />
          </div>
          <div className="field">
            <label>Content</label>
            <div className="editor">
              {state.inviteParents.content && (
                <Editor
                  content={state.inviteParents.content}
                  onChange={({content}: {content: string}) => {
                    change('inviteParents', {content})
                  }}
                />
              )}
            </div>
          </div>
        </fieldset>
      </div>
      <Button
        label={'Save'}
        style={{
          marginTop: 30
        }}
        preload={state.saving}
        onClick={save}
        className={'button-2'}
      />
    </div>
  )
})